export const POSTALCODE_VALIDATE_REQ = "POSTALCODE_VALIDATE_REQ"
export const POSTALCODE_VALIDATE_REQ_FAIL = "POSTALCODE_VALIDATE_REQ_FAIL"